import { connect } from 'react-redux';
import { OAuthCallBack } from '../presentation/OAuthCallBack';


const mapStateToProps = (state, ownProps) => ({
  provider: 'provider' in ownProps.computedMatch.params ? ownProps.computedMatch.params.provider : null,
  session: { ...state.session },
  networkError: state.app.error,
});

export default connect(
  mapStateToProps,
)(OAuthCallBack);



// WEBPACK FOOTER //
// ./scripts/containers/OAuthCallbackContainer.jsx